<template>
    <div>
        <b-modal
            :id="modalId"
            ref="creditConvertForm"
            title-tag="h2"
            :title="`Donate to Charitable Fund`"
            :lazy="true"
            ok-title="Save"
            @ok="proceed()"
            :ok-disabled="isOkDisabled"
            footer-class="d-flex justify-content-between"
        >
            <form name="convert-form">
                <b-form-group label-for="type" label="Apply To:" label-cols="4">
                    <select
                        v-model="fundId"
                        v-validate="'required'"
                        name="repeat"
                        class="form-control"
                        aria-invalid="false"
                    >
                        <option
                            v-for="item in fundTypeOptions"
                            :key="item.id"
                            :value="item.id"
                            :disabled="item.id == -1"
                        >
                            {{ item.name }}</option
                        >
                    </select>
                </b-form-group>
                <b-form-group label-for="note" label="Notes:" label-cols="4">
                    <b-form-textarea
                        v-model="editNote"
                        placeholder="Notes (optional)"
                        rows="3"
                        name="note"
                    ></b-form-textarea>
                </b-form-group>
            </form>
        </b-modal>
    </div>
</template>
<script type="text/javascript">
import Payment from "@/services/payment";
import BillingCreditServices from "@/services/billing/billing-credit";

export default {
    props: {
        modalId: {
            type: String,
            required: true
        },
        credit: {
            type: Object,
            default() {
                return { id: null };
            }
        }
    },
    data() {
        return {
            editNote: null,
            fundId: -1,
            fundTypeOptions: []
        };
    },
    mounted() {
        this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
            if (modalId == this.modalId) {
                this.getCharitableFunds();
            }
        });
    },
    computed: {
        isOkDisabled() {
            return this.fundId == -1;
        }
    },
    methods: {
        proceed() {
            let self = this;

            let params = {
                id: this.credit.id,
                fund_id: this.fundId,
                note: this.editNote
            };

            self.convertCreditToFund(params);
            return;
        },
        convertCreditToFund(params) {

            BillingCreditServices.convertToCharitableFund(params)
                .then(response => {
                    if (response.code == 400 && response.message) {
                        this._message(response.message, "danger");
                    } else if (response.code == 200) {
                        this._message(response.message);
                        this.$emit("reload");
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .catch(error => {
                    this._message("Error : Unable to convert credit", "danger");
                    console.error(error);
                });
        },
        getCharitableFunds() {
            let self = this;

            Payment.getFundList()
                .then(response => {
                    if (response && response.message.code === 200) {
                        self.fundTypeOptions = response.message.resources;
                    }

                    self.fundTypeOptions.unshift({
                        id: -1,
                        name: "Please select a charitable fund (required)"
                    });

                    self.fundId = -1;
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
};
</script>
